export default __webpack_public_path__ + "static/media/application-img-04.c38919c9.png";